import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const eye: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={iconColor}
        d="M15.5,12.0002 C15.5,10.0672 13.933,8.5002 12,8.5002 C10.067,8.5002 8.5,10.0672 8.5,12.0002 C8.5,13.9332 10.067,15.5002 12,15.5002 C13.933,15.5002 15.5,13.9332 15.5,12.0002 Z M20.5,12.0002 C19.756,10.9002 16.25,6.5002 12,6.5002 C7.75,6.5002 4.35,10.7902 3.5,12.0002 C4.244,13.1002 7.75,17.5002 12,17.5002 C16.25,17.5002 19.65,13.2102 20.5,12.0002 Z"
      />
    </svg>
  );
};
